import React from 'react';
import { InternalProvider } from '../../../../util';
import { ModalHeader, ModalMain, ModalTitle, ModalScrollContainer, ModalSubTitle } from './elements';
export const DefaultModal = ({
  title = '',
  titleFontSize,
  subTitle = '',
  children,
  stickyHeader = true
}) => /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(ModalScrollContainer, {
  stickyHeader: stickyHeader
}, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement("div", {
  id: "dialog-title"
}, /*#__PURE__*/React.createElement(ModalTitle, {
  fontSize: titleFontSize
}, title), /*#__PURE__*/React.createElement(ModalSubTitle, null, subTitle))), /*#__PURE__*/React.createElement(ModalMain, {
  stickyHeader: stickyHeader
}, /*#__PURE__*/React.createElement("div", {
  id: "dialog-content"
}, children))));